import React, { useEffect, useMemo, useRef, useState } from "react";
import { PageLoader } from "../../../Components/Loader/PageLoader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  MenuItem,
  Select,
  CardContent,
  Stack,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions
} from "@mui/material";
import {
  useDeleteCustomerMutation,
  useGetAllInvoiceQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetWorkOrderQuery,
} from "../../../Api/attoDeskApi";
import {
  ICompanyDetails,
  IInvoice,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, Link } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import { WorkOrderStatus } from "../../../Core/Enum/enum";
import dayjs from "dayjs";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import LinkIcon from '@mui/icons-material/Link';
import moment from "moment";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import axios from "axios";

dayjs.extend(utc);
dayjs.extend(timezone);

interface Payment {
  id: number;
  work_order_id: number;
  amount: number;
  payment_method: string;
  payment_mode: string;
  created_at: string;
  InvoiceNo: string;
}

interface CashRecord {
  id: number;
  date: string;
  type: "Cash In" | "Cash Out";
  amount: number;
  note?: string;
}

const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
        case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedCoursing, setSelectedCoursing] = useState<IInvoice | null>(
    null
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IInvoice | null>(
    null
  );

  const { data, isLoading, isError, refetch } = useGetAllInvoiceQuery({
    searchText: currentSearchQuery,
    id: "",
    quoteWorkOrderCustomerId: "",
    quoteWorkOrderCustomerProjectId: "",
  });

  const { data: companyData, isLoading: companyLoading } = useGetCompanyQuery({
    searchText: "",
    id: "",
  });
    const [dateFilter, setDateFilter] = useState<string>("today");
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const API_URL = process.env.REACT_APP_API_URL;
    const [payments, setPayments] = useState<Payment[]>([]); 
    const invoiceRef = useRef<HTMLDivElement>(null);
    const paymentRef = useRef<HTMLDivElement>(null);
    const [openPopup, setOpenPopup] = React.useState(false);
const [cashType, setCashType] = React.useState<"in" | "out">("in");
const [amount, setAmount] = React.useState("");
const [runningCash, setRunningCash] = useState(0);
const [cashRecords, setCashRecords] = useState<CashRecord[]>([]);


  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  
    const isWithinDateRange = (createdAt: string | undefined) => {
  if (!dateFilter || !createdAt) return true;

  const saleDate = new Date(createdAt).toLocaleDateString("en-CA");
  const startDateString = new Date(startDate).toLocaleDateString("en-CA");
  const endDateString = new Date(endDate).toLocaleDateString("en-CA");

  return saleDate >= startDateString && saleDate <= endDateString;
};

useEffect(() => {
  fetch(`${API_URL}/payments`)
    .then((res) => res.json())
    .then((data) => {
      setPayments(data);
    })
    .catch((err) => console.error('Error fetching payments:', err));
}, []);

   useEffect(() => {
  if (dateFilter !== "custom") {
    let start = "";
    let end = "";
    const now = dayjs().tz("America/Toronto");
    //const now = dayjs().tz("Etc/GMT+12");

    switch (dateFilter) {
      case "today":
        start = end = now.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = end = now.subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = now.startOf("week").format("YYYY-MM-DD");
        end = now.endOf("week").format("YYYY-MM-DD"); //  Include full week
        break;
      case "last_week":
        start = now.subtract(1, "week").startOf("week").format("YYYY-MM-DD");
        end = now.subtract(1, "week").endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = now.startOf("month").format("YYYY-MM-DD");
        end = now.endOf("month").format("YYYY-MM-DD"); //  Ensure full month is covered
        break;
      case "last_month":
        start = now.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        end = now.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
        break;
      default:
        break;
    }

    setStartDate(start);
    setEndDate(end);
  }
}, [dateFilter]);

const fetchCashRecords = async () => {
  try {
  const res = await axios.get(`${API_URL}/cash-transactions`,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });

    // res.data.data is the array from Laravel
    const records = res.data.data;

    const filteredRecords = records.filter((record: any) =>
      isWithinDateRange(record.created_at)
    );


    setCashRecords(filteredRecords);

 let total = 0;
filteredRecords.forEach((record: any) => {
  const amount = Number(record.amount) || 0; // ensure number
  total += record.type === "cash_in" ? amount : -amount;
});
setRunningCash(total);

  } catch (err) {
    console.error(err);
  }
};
const cashInRecords = cashRecords?.filter(
  (r: any) => r.type === "cash_in"
);

const cashOutRecords = cashRecords?.filter(
  (r: any) => r.type === "cash_out"
);



   useEffect(() => {
  fetchCashRecords();
}, [dateFilter,startDate, endDate]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IInvoice) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
   
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IInvoice) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteCustomerMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the customer");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer");
    }
  };

  if (isLoading) return <PageLoader height="10vh" />;

    const coursings: IInvoice[] = Array.isArray(data?.data)
    ? (data?.data as IInvoice[])
    : [];

  







const filteredCoursings = coursings.filter((row) => {
  return row.Mode === 'POS' && isWithinDateRange(row.created_at);
});


const filteredPayments = payments.filter((row) => {
    const matchedInvoice = coursings.find(
    (item) => item.work_order_id === row.work_order_id
  );



  const isPOS = matchedInvoice?.Mode === 'POS';
  return  isPOS  && isWithinDateRange(row.created_at);
});

    // const filteredCoursings = coursings.filter((row) => {

    //   const isPOS = row.Mode === 'POS';
     
    //   const matchesDate =
    //     !dateFilter || (() => {
    //       if (!row.created_at) return false; 
    //         const saleDate = new Date(row.created_at).toLocaleDateString("en-CA");
    //         const startDateString = new Date(startDate).toLocaleDateString("en-CA");
    //         const endDateString = new Date(endDate).toLocaleDateString("en-CA");
    
    //         const isValid = saleDate >= startDateString && saleDate <= endDateString;
    //         return isValid;
    //       })();
    
    
    
    //   return  isPOS && matchesDate ;
    // });

       const totalInvoices = filteredCoursings.length;

// Total payments sum
const totalPayments = filteredPayments.reduce((sum, invoice) => {
  return sum + Number(invoice.amount || 0); // assuming `settledAmount` holds payment
}, 0);

const totalCash = filteredPayments
  .filter(payment => payment.payment_method?.toLowerCase() === 'cash')
  .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);

const totalCredit = filteredPayments
  .filter(payment => payment.payment_method?.toLowerCase() === 'credit')
  .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);

const totalDebit = filteredPayments
  .filter(payment => payment.payment_method?.toLowerCase() === 'debit')
  .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);


  // Calculate totals per payment method and mode
const paymentSummary = ["cash", "credit", "debit"].map((method) => {
  const instore = filteredPayments
    .filter(p => p.payment_method?.toLowerCase() === method && p.payment_mode?.toLowerCase() === "offline")
    .reduce((sum, p) => sum + Number(p.amount || 0), 0);

  const online = filteredPayments
    .filter(p => p.payment_method?.toLowerCase() === method && p.payment_mode?.toLowerCase() === "online")
    .reduce((sum, p) => sum + Number(p.amount || 0), 0);

  return { method, instore, online };
});

const totalInStore = paymentSummary.reduce(
  (sum, item) => sum + item.instore,
  0
);

const totalOnline = paymentSummary.reduce(
  (sum, item) => sum + item.online,
  0
);


const walkInCount = filteredCoursings.filter(
  inv => String(inv.quoteWorkOrderCustomerId) === "0"
).length;


const totalClients = new Set(
  filteredCoursings
    .filter(inv => String(inv.quoteWorkOrderCustomerId) !== "0")
    .map(inv => inv.quoteWorkOrderCustomerId)
).size;

    
    

  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };

  const handleAddProductClick = () => {
    navigate("/quote/create");
  };


  const dateOptions = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "This Week", value: "this_week" },
  { label: "Last Week", value: "last_week" },
  { label: "This Month", value: "this_month" },
  { label: "Last Month", value: "last_month" },
  { label: "Custom", value: "custom" }
];


const handleOpenPopup = (type: "in" | "out") => {
  setCashType(type);
  setOpenPopup(true);
};


const handleSaveCash = async () => {
  if (!amount || isNaN(Number(amount))) return;

  try {
    const payload = {
      type: cashType === "in" ? "cash_in" : "cash_out", // ✅ match Laravel
      amount: Number(amount),
      note:  "" // optional
    };

    const res = await axios.post(`${API_URL}/save-cash`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });

    // Add record to UI
    setCashRecords((prev) => [res.data.data, ...prev]);

    setRunningCash((prev) =>
      payload.type === "cash_in" ? prev + payload.amount : prev - payload.amount
    );
    

    // Reset modal
    setAmount("");
    setOpenPopup(false);

  } catch (error: any) {
    console.error("API Error:", error.response?.data || error);
  }
};

 


  return (

    <><Grid container spacing={1} sx={{ marginTop: 1 }}>
      <Grid item xs={12}>
        <Card className={classes.card}>
          <Box  padding={2}>
            <Grid container spacing={2}>
              
              {/* Select Date */}
              <Grid item xs={8}>
                {/* <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                  Select Date
                </Typography> */}
                {/* <Select
                  className={classes.textField}
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                  displayEmpty

                  sx={{
                    height: "37px",
                    fontSize: "14px",
                    padding: "4px",
                    minWidth: "120px"
                  }}
                >
                  <MenuItem value="">Select date filter</MenuItem>
                  <MenuItem value="today">Today</MenuItem>
                  <MenuItem value="yesterday">Yesterday</MenuItem>
                  <MenuItem value="this_week">This Week</MenuItem>
                  <MenuItem value="last_week">Last Week</MenuItem>
                  <MenuItem value="this_month">This Month</MenuItem>
                  <MenuItem value="last_month">Last Month</MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </Select> */}

 <Grid container spacing={1}>
    {dateOptions.map((option) => (
      <Grid item key={option.value}>
        <Button
          variant={dateFilter === option.value ? "contained" : "outlined"}
          onClick={() => setDateFilter(option.value)}
          size="small"
          sx={{ fontSize: "13px", padding: "6px 12px" }}
        >
          {option.label}
        </Button>
      </Grid>
    ))}
  </Grid>




              </Grid>

              {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
              {dateFilter === "custom" && (
                <>
                  <Grid item lg={2} md={2} sm={6} xs={12}>
                    {/* <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                      Start Date
                    </Typography> */}
                    <TextField
                      variant="outlined"
                      label="Start Date"
                      type="date"
                      size="small"
                      className={classes.textField}
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      InputLabelProps={{ shrink: true }} />
                  </Grid>
                  <Grid item lg={2} md={2} sm={6} xs={12}>
                    {/* <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                      End Date
                    </Typography> */}
                    <TextField
                      label="End Date"
                      type="date"
                      size="small"
                      className={classes.textField}
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      InputLabelProps={{ shrink: true }} />
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Card>
      </Grid>
    </Grid>
    
    
    <Box sx={{ marginTop: 4 }}>
   <Grid container spacing={4} justifyContent="center" >
    
  
  {/* LEFT CARD - TOTAL SALES */}
  <Grid item xs={12} sm={6} md={6}>
    <Card elevation={3} sx={{ height: "450px", display: "flex", flexDirection: "column",  boxShadow: "none", }}>
      <CardContent sx={{ flex: 1,  p: 0  }}>
          <Box
        sx={{
          backgroundColor: "rgb(225 225 225)", 
          //borderRadius: 2,
          padding: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {/* Amount on top */}
        <Typography
          variant="h3"
          align="center"
          sx={{ fontWeight: "bold", color: "#5d7186", mb: 1, fontSize: { xs: "1rem", sm: "1.5rem", md: "2.5rem" }, }}
        >
          ${totalPayments.toFixed(2)}
        </Typography>

        {/* Heading below */}
        <Typography
          variant="h5"
          align="center"
          sx={{ fontWeight: "bold", color: "#5d7186" }}
        >
          Total Sales
        </Typography>
      </Box>

        {/* Payment Method Table */}
        <Box mt={6} sx={{ maxHeight: "250px", overflowY: "auto", padding: '5px' }}>
          <Table className={classes.table} stickyHeader>
           <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader} sx={{ fontWeight: "bold" }}>Method</TableCell>
                <TableCell className={classes.tablheader} sx={{ fontWeight: "bold" }}>In-Store</TableCell>
                <TableCell className={classes.tablheader} sx={{ fontWeight: "bold" }}>Online</TableCell>
              </TableRow>
            </TableHead>

          <TableBody>
      {paymentSummary.map((pm, idx) => (
        <TableRow key={idx}>
          <TableCell scope="row" className={classes.tablCell}>{pm.method.charAt(0).toUpperCase() + pm.method.slice(1)}</TableCell>
          <TableCell scope="row" className={classes.tablCell}>${pm.instore.toFixed(2)}</TableCell>
          <TableCell scope="row" className={classes.tablCell}>${pm.online.toFixed(2)}</TableCell>
        </TableRow>

      ))}

        {paymentSummary.length > 0 && (
    <TableRow
      sx={{
        backgroundColor: "rgb(225, 225, 225)",
        // position: "sticky",
        // bottom: 0,
        // zIndex: 1,
      }}
    >
      <TableCell sx={{
      fontWeight: 600,
      // fontSize: "1rem",
      color: "#5d7186",
    }}>
        Total
      </TableCell>

      <TableCell sx={{
      fontWeight: 600,
      // fontSize: "1rem",
      color: "#5d7186",
    }}>
        ${totalInStore.toFixed(2)}
      </TableCell>

      <TableCell sx={{
      fontWeight: 600,
      // fontSize: "1rem",
      color: "#5d7186",
    }}>
        ${totalOnline.toFixed(2)}
      </TableCell>
    </TableRow>
  )}

      {paymentSummary.length === 0 && (
        <TableRow>
          <TableCell colSpan={2} align="center">
            No data
          </TableCell>
        </TableRow>
      )}
    </TableBody>
          </Table>
        </Box>
      </CardContent>
    </Card>
  </Grid>

  {/* RIGHT CARD - RUNNING CASH */}
  <Grid item xs={12} sm={6} md={6}>
    <Card elevation={3} sx={{ height: "450px", display: "flex", flexDirection: "column", boxShadow: "none", }}>
      <CardContent sx={{ flex: 1 ,p: 0}}>
          <Box
        sx={{
          backgroundColor: "#2e7d32", // blue background
          // borderRadius: 2,
          padding: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {/* Amount on top */}
        <Typography
          variant="h3"
          align="center"
          sx={{ fontWeight: "bold", color: "#fff", mb: 1, fontSize: { xs: "1rem", sm: "1.5rem", md: "2.5rem" } }}
        >
           ${((Number(totalCash) || 0) + (Number(runningCash) || 0)).toFixed(2)}

        </Typography>

        {/* Heading below */}
        <Typography
          variant="h5"
          align="center"
          sx={{ fontWeight: "bold", color: "#fff" }}
        >
          Running Cash
        </Typography>
      </Box>
       

       
  
        {/* Cash In / Cash Out Buttons */}
         <Box display="flex" justifyContent="flex-end" gap={2} mt={1.3} px={2}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => handleOpenPopup("in")}
             style={{ visibility: dateFilter === "today" ? "visible" : "hidden" }}
          >
            Cash In
          </Button>

          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => handleOpenPopup("out")}
             style={{ visibility: dateFilter === "today" ? "visible" : "hidden" }}
          >
            Cash Out
          </Button>
        </Box>

   
 <Box mt={1} sx={{  height: "240px",   display: "flex",
    flexDirection: "column", padding: '5px'}}>
       <TableContainer sx={{ flex: 1, overflowY: "auto" }}>
          <Table  className={classes.table} stickyHeader >
            <TableHead>
              <TableRow>
                <TableCell  className={classes.tablheader} sx={{ fontWeight: "bold" }}>Date</TableCell>
                <TableCell className={classes.tablheader} sx={{ fontWeight: "bold", color: "green" }}> Cash In</TableCell>
               <TableCell className={classes.tablheader} sx={{ fontWeight: "bold", color: "red" }}> Cash Out</TableCell>
                <TableCell  className={classes.tablheader} sx={{ fontWeight: "bold" }}>Updated By</TableCell>
                {/* <TableCell  className={classes.tablheader} sx={{ fontWeight: "bold" }}>Updated By</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {cashRecords.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                cashRecords.map((record: any, idx: any) => (
                  <TableRow key={idx}>
                    <TableCell scope="row" className={classes.tablCell}> {moment(record.created_at).format('DD-MMM-YY hh:mm A')}</TableCell>
                     <TableCell className={classes.tablCell} sx={{ color: "green", fontWeight: "bold" }} >  {record.type === "cash_in"
                  ? `$${Number(record.amount).toFixed(2)}`
                  : "-"} </TableCell>
                <TableCell
                className={classes.tablCell}
                sx={{ color: "red", fontWeight: "bold" }}
              >
                {record.type === "cash_out"
                  ? `$${Number(record.amount).toFixed(2)}`
                  : "-"}
              </TableCell>
                    <TableCell scope="row" className={classes.tablCell} > {record.updated_by ?? "-"}</TableCell>
                  </TableRow>
                ))
              )}
              

              {cashRecords.length > 0 && (

                   <TableRow
        sx={{
          backgroundColor: "#e1e1e1",
          position: "sticky",
          bottom: 0,
          zIndex: 2,
        }}
      >
        <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
        <TableCell sx={{ fontWeight: "bold", color: "green" }}>
          {`$${cashRecords
            .filter((r: any) => r.type === "cash_in")
            .reduce((s: number, r: any) => s + Number(r.amount), 0)
            .toFixed(2)}`}
        </TableCell>
        <TableCell sx={{ fontWeight: "bold", color: "red" }}>
          {`$${cashRecords
            .filter((r: any) => r.type === "cash_out")
            .reduce((s: number, r: any) => s + Number(r.amount), 0)
            .toFixed(2)}`}
        </TableCell>
        <TableCell></TableCell>
      </TableRow>

              )}

                 </TableBody>
          </Table>
          </TableContainer>
         
        </Box>

      </CardContent>
    </Card>
  </Grid>

</Grid>
    </Box>
      
      
      
      
      <Grid container spacing={4} justifyContent="center" sx={{ marginTop: 1 }}>
        {/* Card 1 */}
        <Grid item xs={12} sm={2} md={2}>
          <Card elevation={3} >
            <CardContent>
              <Grid container direction="column" alignItems="center">
                {/* <FaClipboardList size={40} color="#4CAF50" /> */}
                <Typography variant="h5" mt={2}>
                  Total Invoice
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                >
              {totalInvoices}
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      
        <Grid item xs={12} sm={2} md={2}>
          <Card elevation={3} >
            <CardContent>
              <Grid container direction="column" alignItems="center">
                {/* <FaClipboardList size={40} color="#4CAF50" /> */}
                <Typography variant="h5" mt={2}>
                  Total Payments
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                >
              ${totalPayments.toFixed(2)}
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

          <Grid item xs={12} sm={2} md={2}>
          <Card elevation={3} >
            <CardContent>
              <Grid container direction="column" alignItems="center">
                {/* <FaClipboardList size={40} color="#4CAF50" /> */}
                <Typography variant="h5" mt={2}>
                   Cash
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                >
              ${totalCash.toFixed(2)}
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={2} md={2}>
          <Card elevation={3} >
            <CardContent>
              <Grid container direction="column" alignItems="center">
                {/* <FaClipboardList size={40} color="#4CAF50" /> */}
                <Typography variant="h5" mt={2}>
                   Credit
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                >
              ${totalCredit.toFixed(2)}
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

         <Grid item xs={12} sm={2} md={2}>
          <Card elevation={3} >
            <CardContent>
              <Grid container direction="column" alignItems="center">
                {/* <FaClipboardList size={40} color="#4CAF50" /> */}
                <Typography variant="h5" mt={2}>
                   Debit
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                >
              ${totalDebit.toFixed(2)}
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

         {/* <Grid item xs={12} sm={2} md={2}>
          <Card elevation={3} >
            <CardContent>
              <Grid container direction="column" alignItems="center">
          
                <Typography variant="h5" mt={2}>
                  Walk In Customers
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                >
                {walkInCount}
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        </Grid> */}
      
      
        <Grid item xs={12} sm={2} md={2}>
          <Card elevation={3} >
            <CardContent>
              <Grid container direction="column" alignItems="center">
                {/* <FaClipboardList size={40} color="#4CAF50" /> */}
                <Typography variant="h5" mt={2}>
                  Total Clients
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                >
                {totalClients}
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      
      
      
      </Grid>
      
      
      
     {/* Charts Section */}
<Box sx={{ marginTop: 4 }}>
  <Grid container spacing={4} justifyContent="center">
    {/* Invoice Count Chart */}
    <Grid item xs={12} md={6}>
      <Card elevation={3}>
        <CardContent>
          <Typography variant="h6" align="center" mb={2}>
            Invoice Count by Customer Type
          </Typography>
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: { type: 'pie' },
              title: { text: '' },
              series: [
                {
                  name: 'Invoices',
                  colorByPoint: true,
                  data: [
                    { name: 'Walk-In', y: walkInCount },
                    { name: 'Clients', y: totalClients },
                  ],
                },
              ],
            }}
          />
        </CardContent>
      </Card>
    </Grid>

    {/* Payment Total Chart */}
    <Grid item xs={12} md={6}>
      <Card elevation={3}>
        <CardContent>
          <Typography variant="h6" align="center" mb={2}>
            Payments by Customer Type
          </Typography>
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: { type: 'column' },
              title: { text: '' },
              xAxis: {
                categories: ['Walk-In', 'Clients'],
              },
              yAxis: {
                min: 0,
                title: { text: 'Amount ($)' },
              },
            series: [
  {
    name: 'Amount Paid',
    // data: [
    //   parseFloat(
    //     filteredCoursings
    //       .filter((inv) => String(inv.quoteWorkOrderCustomerId) === '0')
    //       .reduce((sum, inv) => sum + Number(inv.amount_paid || 0), 0)
    //       .toFixed(2)
    //   ),
    //   parseFloat(
    //     filteredCoursings
    //       .filter((inv) => String(inv.quoteWorkOrderCustomerId) !== '0')
    //       .reduce((sum, inv) => sum + Number(inv.amount_paid || 0), 0)
    //       .toFixed(2)
    //   ),
    // ],
 data: [
    // Payments with quoteWorkOrderCustomerId === '0'
    parseFloat(
      filteredPayments
        .filter((payment) => {
          const matchedInvoice = coursings.find(
            (inv) => inv.work_order_id === payment.work_order_id
          );
          return matchedInvoice?.quoteWorkOrderCustomerId === '0';
        })
        .reduce((sum, payment) => sum + Number(payment.amount || 0), 0)
        .toFixed(2)
    ),
    // Payments with quoteWorkOrderCustomerId !== '0'
    parseFloat(
      filteredPayments
        .filter((payment) => {
          const matchedInvoice = coursings.find(
            (inv) => inv.work_order_id === payment.work_order_id
          );
          return matchedInvoice?.quoteWorkOrderCustomerId !== '0';
        })
        .reduce((sum, payment) => sum + Number(payment.amount || 0), 0)
        .toFixed(2)
    ),
  ]
    
  },
],

            }}
          />
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Box>
 
      
      <Grid container spacing={1}  sx={{ marginTop: 1 }}>
        <Grid item xs={12} sm={12} md={12}>
    <Card className={classes.card}>

      <div ref={invoiceRef} >
        <Grid
          container
          justifyContent={"space-between"}
          spacing={5}
          sx={{ borderBottom: 2, padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
            <Typography className={classes.cardTitle}>Invoices</Typography>
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xs={8}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
              <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CiSearch className={classes.searchWidgetIcon} />
                      </InputAdornment>
                    ),
                    classes: {
                      root: classes.formControlList,
                    },
                  }}
                  fullWidth
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Invoice Number .."
                  sx={{ width: "100%" }}
                  size="small" />
              </Grid>

   {filteredCoursings.length > 0 && (
  <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => invoiceRef.current}
    />
  </Grid>
)}
         
            </Grid>
          </Grid>
        </Grid>

        <Grid>
          <TableContainer>
            <Table className={classes.table}>
              <TableHead className={classes.tableHeaderRow}>
                <TableRow>
                  <TableCell className={classes.tablheader}>
                    <CustomCheckbox name="checkbox" />
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>#</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Invoice Number</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Mode</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Status</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Amount</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Paid Amount</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Balance</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Issue From</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Issue For</strong>
                  </TableCell>

                  {/* <TableCell className={classes.tablheader}>
      <strong>Status</strong>
    </TableCell> */}
                  <TableCell
                    className={classes.tablheader}
                     sx={{ textAlign: "right" ,'@media print': {
                      display: 'none',
                    } }}
                  >
                    <strong>Actions</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isError || filteredCoursings.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={20} align="center">
                      {isError ? "Error fetching data" : "No data available"}
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredCoursings
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: IInvoice, index) => {
                      const statusLabel = getStatusLabel(
                        row.quoteWorkOrderStatus
                      );
                      const statusColor = getStatusColor(
                        row.quoteWorkOrderStatus
                      );

                      const balance = Math.max(0, parseFloat(row.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(row.amount_paid || "0")));

                      return (
                        <TableRow key={row.id} className={classes.tableRowHover}>
                          <TableCell className={classes.tablCell}>
                            <CustomCheckbox name="checkbox" />
                          </TableCell>

                          <TableCell scope="row" className={classes.tablCell}>
                            {page * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                            sx={{ whiteSpace: "nowrap"}} // Prevents line break & makes it clickable
                          //  onClick={() => navigate(`/work-order/history/${row.work_order_id}`)} // Use backticks
                          >
                       <Link  to={`/work-order/history/${row.work_order_id}`} // Replace with the correct path to your desired page
                         style={{ textDecoration: 'none', display:'flex', color: 'inherit',cursor: 'pointer', }} >
                         
                         {row.InvoiceNo}
                           &nbsp;
                        <LinkIcon fontSize="small" />
                         </Link>
                          </TableCell>

                          <TableCell scope="row" className={classes.tablCell}>
                            {row.Mode}
                          </TableCell>

                          <TableCell scope="row" className={classes.tablCell}>
                            <Button
                              className={classes.statusButtonList}
                              style={{
                                color: statusColor,
                                backgroundColor: row.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                  ? "#e1f8d5"
                                  : row.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                    ? "#f8d7da"
                                    : row.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                      ? "lightyellow"
                                      : row.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                        ? "#e2fafa"
                                        : "#ffffff", // Fallback for other statuses
                                border: "solid 1px",
                                borderColor: statusColor,
                                borderRadius: "8px",
                              }}
                            >
                              {statusLabel}
                            </Button>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {"$"}
                            {parseFloat(
                              row.quoteWorkOrderSaleGrandTotal || "0"
                            ).toFixed(2)}

                          </TableCell>
                          <TableCell component="th" scope="row" className={classes.tablCell}>
                          {"$"}{(row.amount_paid || "0")}
                             {/* {"$"}{(row.Customer_paid || "0")} */}
                          </TableCell>

                          <TableCell component="th" scope="row" className={classes.tablCell}>
                            {"$"}{balance.toFixed(2)}
                                 {/* {"$"}{row.Change} */}
                          </TableCell>

                          <TableCell scope="row" className={classes.tablCell}>
                            {row.company.companyName || row.project.projectName || ""}

                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid container>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                {row.project?.projectName || row.customer?.customerCompanyName || ""}
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>

                                {row.customer ? (
    <Link
      to={`/customer-history/${row.quoteWorkOrderCustomerId}`}
      style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', color: 'inherit', cursor: 'pointer' }}
    >
      (
      {`${row.customer.customerFirstName?.charAt(0).toUpperCase() + row.customer.customerFirstName?.slice(1).toLowerCase() || ""} 
        ${row.customer.customerLastName?.charAt(0).toUpperCase() + row.customer.customerLastName?.slice(1).toLowerCase() || ""}`}
      )
      &nbsp;
      <LinkIcon fontSize="small" />
    </Link>
  ) : (
    "Walk-in"
  )}
                              </Grid>
                            </Grid>
                          </TableCell>

                          {/* <TableCell scope="row" className={classes.tablCell}>
                      <Button
                        className={classes.statusButtonList}
                        style={{
                          color: statusColor,
                          border: "solid 1px",
                          borderColor: statusColor,
                          borderRadius: "8px",
                        }}
                      >
                        {statusLabel}
                      </Button>
                    </TableCell> */}
                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid
                              container
                              spacing={1}
                              sx={{ display: "flex", justifyContent: "flex-end" }}
                            >


                              <Grid item  sx={{ '@media print': {
                    display: 'none',
                  } }}>
                                  <Link   className={classes.viewButtonList}
                                                        to={`/invoicePos/history/${row.id}`} // Replace with the correct path to your desired page
                                                        style={{ textDecoration: 'none', color: 'inherit',cursor: 'pointer', }} // Optional: style to remove link styling
                                                      >
                                                         <VisibilitySharpIcon
                                                                  className={classes.viewListIcon}
                                                                />
                                    </Link>
                                {/* <Button
                                  variant="contained"
                                  className={classes.viewButtonList}
                                  onClick={() => navigate(`/invoicePos/history/${row.id}`)}
                                >
                                  <VisibilitySharpIcon
                                    className={classes.viewListIcon} />
                                </Button> */}
                              </Grid>



                              {/* <Grid item>
                                <Button
                                  variant="contained"
                                  className={classes.editButtonList}
                                  onClick={() => navigate(
                                    row.project?.id
                                      ? `/invoice/project/edit/${row.id}` // Redirect to project-specific edit page
                                      : `/invoice/edit/${row.id}` // Redirect to regular edit page
                                  )}
                                >
                                  <EditSharpIcon className={classes.editListIcon} />
                                </Button>

                              </Grid> */}


                            </Grid>
                          </TableCell>
                        </TableRow>
                        
                      );
                     

                    })
                )}

                 <TableRow>
  {/* <TableCell colSpan={5} className={classes.tablCell} style={{ fontWeight: 'bold' }}>
    Total
  </TableCell> */}
   <TableCell className={classes.tablCell} />
  <TableCell className={classes.tablCell} />
  <TableCell className={classes.tablCell} />
  <TableCell className={classes.tablCell} />

  <TableCell className={classes.tablCell} style={{ fontWeight: 'bold' }}>
    Total
  </TableCell>
  <TableCell className={classes.tablCell} style={{ fontWeight: 'bold' }}>
    ${filteredCoursings.reduce((sum, row) => sum + parseFloat(row.quoteWorkOrderSaleGrandTotal || "0"), 0).toFixed(2)}
  </TableCell>
 <TableCell className={classes.tablCell} style={{ fontWeight: 'bold' }}>
  ${filteredCoursings.reduce((sum, row) => sum + parseFloat(String(row.amount_paid || "0")), 0).toFixed(2)}
</TableCell>
<TableCell className={classes.tablCell} style={{ fontWeight: 'bold' }}>
  ${ (filteredCoursings.reduce((sum, row) => sum + parseFloat(String(row.quoteWorkOrderSaleGrandTotal ?? "0")), 0)
    - filteredCoursings.reduce((sum, row) => sum + parseFloat(String(row.amount_paid ?? "0")), 0)
  ).toFixed(2) }
</TableCell>


  <TableCell className={classes.tablCell} colSpan={3} />
</TableRow>
              </TableBody>
            </Table>
            <Grid sx={{ '@media print': { display: 'none',  } }}
              spacing={5}
              p={"18px"}
              py={4}
              justifyContent={"end"}
              container
              textAlign={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid
                sx={{
                  textAlign: "end",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Pagination
                  count={filteredCoursings.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage} />
              </Grid>
            </Grid>
          </TableContainer>

        </Grid>
        </div>
      </Card>
      </Grid>
      </Grid>  


       <Grid container spacing={1}  sx={{ marginTop: 1 }}>
        <Grid item xs={12} sm={12} md={12}>
          <div ref={paymentRef} >
    <Card className={classes.card}>
        <Grid
          container
          justifyContent={"space-between"}
          spacing={5}
          sx={{ borderBottom: 2, padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
            <Typography className={classes.cardTitle}>Payments</Typography>
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xs={8}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
            
{filteredPayments.length > 0 && (
  <Grid item sx={{ '@media print': {
    display: 'none',
  } }}>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => paymentRef.current}
    />
  </Grid>
)}

            </Grid>
          </Grid>
        </Grid>

        <Grid>
          <TableContainer>
            <Table className={classes.table}>
                       <TableHead className={classes.tableHeaderRow}>
                         <TableRow>
                          <TableCell className={classes.tablheader}>
                             <strong>Date</strong>
                           </TableCell>
                           <TableCell className={classes.tablheader}>
                             <strong>Invoice Number</strong>
                           </TableCell>
                           <TableCell className={classes.tablheader}>
                             <strong>Mode</strong>
                           </TableCell>
                           <TableCell className={classes.tablheader}>
                             <strong>Amount</strong>
                           </TableCell>
                           <TableCell className={classes.tablheader}>
                             <strong>Method</strong>
                           </TableCell>
                         
                        
                           
                         </TableRow>
                       </TableHead>
                       <TableBody>
                         {isError || payments.length === 0 ? (
                           <TableRow>
                             <TableCell colSpan={20} align="center">
                               {isError ? "Error fetching data" : "No data available"}
                             </TableCell>
                           </TableRow>
                         ) : (
                           filteredPayments
                          
                             .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                             .map((row: Payment, index) => {
                              
                               const matchedInvoice = coursings.find(
                                 (item) => item.work_order_id === row.work_order_id
                               );
                           
                               // Get the mode if invoice is found
                               const mode = matchedInvoice?.Mode || "Manual"; // fallback to "N/A" if not found
           
           
                               return (
                                 <TableRow key={row.id} className={classes.tableRowHover}>
                                 
                                  <TableCell component="th" scope="row" className={classes.tablCell}>
                                   {moment(row.created_at).format("DD-MMM-YY")}
                                    </TableCell>

                                   <TableCell
                                     component="th"
                                     scope="row"
                                     className={classes.tablCell}
                                     sx={{ whiteSpace: "nowrap" }} 
                                   >
                                     {row.InvoiceNo}
                                   </TableCell>
                                   <TableCell scope="row" className={classes.tablCell}>
                                    {mode}
                                   </TableCell>
                                  
                                   <TableCell
                                     component="th"
                                     scope="row"
                                     className={classes.tablCell}
                                   >
                                       {"$"}
                                             {row.amount}
                                    
                                   </TableCell>
                                   <TableCell  component="th" scope="row"  className={classes.tablCell}>
                                       {row.payment_method}
                                   </TableCell>
                                  
                                  
                               
                                 </TableRow>
                               );
                             })
                         )}

                         <TableRow>

   <TableCell className={classes.tablCell} />
  <TableCell className={classes.tablCell} />

  <TableCell className={classes.tablCell} style={{ fontWeight: 'bold' }}>
    Total
  </TableCell>
 <TableCell className={classes.tablCell} style={{ fontWeight: 'bold' }}>
  ${filteredPayments.reduce((sum, row) => sum + parseFloat(String(row.amount || "0")), 0).toFixed(2)}
</TableCell>




  <TableCell className={classes.tablCell} colSpan={3} />
</TableRow>
                       </TableBody>
                     </Table>
            <Grid sx={{ '@media print': {
                      display: 'none',
                    } }}
              spacing={5}
              p={"18px"}
              py={4}
              justifyContent={"end"}
              container
              textAlign={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid
                sx={{
                  textAlign: "end",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Pagination
                  count={filteredPayments.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage} />
              </Grid>
            </Grid>
          </TableContainer>

        </Grid>
      </Card>
      </div>
      </Grid>
      </Grid>  
      
      <Dialog open={openPopup} onClose={() => setOpenPopup(false)}>
  <DialogTitle>{cashType === "in" ? "Cash In" : "Cash Out"}</DialogTitle>
  <DialogContent sx={{ minWidth: "300px" }}>
    <TextField
      label="Amount"
      fullWidth
      type="number"
      value={amount}
      onChange={(e) => setAmount(e.target.value)}
      sx={{ mt: 1 }}
    />
  </DialogContent>
  <DialogActions>
     <Grid item lg={12} md={12} sm={12} xs={12} >
     
        <Grid container p={"24px"}>
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
    {/* <Button   className={classes.addButton} onClick={() => setOpenPopup(false)}>Cancel</Button> */}
    <Button variant="contained"   className={classes.addButton} onClick={handleSaveCash}>
      Save
    </Button>
    </Grid>
    </Grid>
    </Grid>
  </DialogActions>
</Dialog>

      
      
      
      
      </>
  );
};

export default Index;
